<template>
    <layout-card
        :isCustomizable="settings.isCustomizable"
        @hide-card="$emit('hide-card', 'marketing_campaign')"
        @refresh-card="fetchCard('marketing_campaign', {}, true)"
        :placeholder="placeholder"
        placeholderImg="/ressources/logged/img/dashboard/dashboard-marketing.svg"
        class="card-marketing_campaign"
        :error="error"
        :loading="loading"
    >
        <!-- SLOTED TITLE -->
        <template slot="title">
            {{ name }}
            <span class="fs-3 regular gray-60 ml-2">{{
                $l10n.__('10 dernières campagnes envoyées')
            }}</span>
        </template>

        <!-- SLOTED ACTIONS -->
        <template slot="actions">
            <CompassIconButton v-if="settings.canCreate" icon="plus" onclick="Campaign.create()" />
        </template>

        <!-- SLOTED CONTENT -->
        <template slot="content">
            <div
                v-if="(cardData && cardData.length > 0) || (cardData && cardData.error)"
                onresize="resizeCard()"
                class="hp-10"
            >
                <div v-if="!cardData.error">
                    <el-table
                        ref="table"
                        :data="cardData"
                        header-cell-class-name="grey semibold"
                        row-class-name="no-hover"
                        class="table-ellipsis"
                        height="100%"
                        stripe
                        style="width: 100%"
                    >
                        <el-table-column prop="name" width="250">
                            <template slot-scope="scope">
                                <a :href="scope.row.link" id="link">
                                    <span class="gray-100 semibold">{{ scope.row.name }}</span>
                                    <p class="grey mt-1">
                                        {{ scope.row.date | dateFormatter('SLASHED_DATE_TIME') }}
                                    </p>
                                </a>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="recipients"
                            :label="$t.__('dashboard.cards.MarketingCampaignCard.recipients')"
                            header-align="right"
                            align="right"
                        >
                            <template slot-scope="scope">
                                <p>{{ formatStats(scope.row.recipients) }}</p>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="open"
                            :label="$t.__('dashboard.cards.MarketingCampaignCard.opening')"
                            header-align="right"
                            align="right"
                        >
                            <template slot-scope="scope">
                                <p>{{ scope.row.open | numberformat }}%</p>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="click"
                            :label="$t.__('dashboard.cards.MarketingCampaignCard.clics')"
                            header-align="right"
                            align="right"
                        >
                            <template slot-scope="scope">
                                <p>{{ formatStats(scope.row.click) }}</p>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="unsub"
                            :label="$t.__('dashboard.cards.MarketingCampaignCard.unsubscribed')"
                            header-align="right"
                            align="right"
                        >
                            <template slot-scope="scope">
                                <p>{{ scope.row.unsub | numberformat }}%</p>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </template>
    </layout-card>
</template>

<script>
import LayoutCard from './LayoutCard.vue';
import CardMixin from './CardMixin.js';
export default {
    mixins: [CardMixin],
    created() {
        window.EventBus.$on('refresh_event', () => {
            this.fetchCard(this.type);
        });

        EventBus.$on('doLayoutCard', () => {
            this.$refs.table.doLayout();
        });
    },
    methods: {
        formatStats(number) {
            const numformat = {
                ...App.numformat,
                ...{ decimals: ' ', precision: 0, currency: '' },
            };
            return NumberFormat.formatToDisplayWithCurrency(number, numformat);
        },
    },
    computed: {
        placeholder() {
            return this.$l10n.__('Aucune campagne marketing à afficher');
        },
    },
    components: {
        LayoutCard,
    },
};
</script>

<style lang="scss">
@import '~@sellsy/styleguide/src/_variables';
@import '~@sellsy/styleguide/src/_mixins';

.card-marketing_campaign {
    .el-table__row--striped.no-hover:hover > td {
        background-color: #fafafa !important;
    }
    .no-hover:hover > td {
        background-color: transparent !important;
    }

    #link {
        &:hover {
            span {
                color: $primary-50 !important;
            }
        }
    }

    .el-table::before {
        background-color: transparent;
    }
}
</style>
